"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creatOKXWalletInfo = creatOKXWalletInfo;
exports.creatOKXMiniAppWalletInfo = creatOKXMiniAppWalletInfo;
const constants_1 = require("../constants");
function creatOKXWalletInfo() {
    return {
        "appName": "okxAppWallet",
        "name": "OKX Wallet",
        "imageUrl": "https://static.okx.com/cdn/assets/imgs/247/58E63FEA47A2B7D7.png",
        "aboutUrl": constants_1.downloadUrl,
        "universalLink": constants_1.standardUniversalLink,
        "deepLink": constants_1.standardDeeplink,
        "platforms": ["ios", "android"]
    };
}
function creatOKXMiniAppWalletInfo() {
    return {
        "appName": "okxMiniApp",
        "name": "OKX Mini Wallet",
        "imageUrl": "https://static.okx.com/cdn/assets/imgs/247/58E63FEA47A2B7D7.png",
        "aboutUrl": constants_1.downloadUrl,
        "universalLink": `https://t.me/${constants_1.tgwalletName}/start`,
        "deepLink": "",
        "platforms": ["ios", "android", 'macos', 'windows']
    };
}
